import {useDispatch, useSelector} from "react-redux";
import {css, cx} from "@panda/css";
import type {Dispatch} from "redux";

import type {IFormValuesAction} from "@pg-mono/form";

import {IRPStore} from "../../../app/rp_reducer";
import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {SearchTab} from "../../../search/types/SearchTab";
import {promotionListFilterFormActions} from "../../actions/promotion_list_filter_fields_actions";
import {PromotionType} from "../../helpers/PromotionType";
import {usePromotionListFilterChange} from "../hooks/usePromotionListFilterChange";
import {IPromotionListFilterFields, PromotionListFilters} from "./filters/PromotionListFilters";
import {PromotionListHeaderResults} from "./PromotionListHeaderResults";

interface IProps {
    className?: string;
}
export const PromotionListHeader = (props: IProps) => {
    const dispatch: Dispatch<IFormValuesAction<unknown>> = useDispatch();

    const formValues = useSelector((state: IRPStore) => state.promotionList.form.formValues) as IPromotionListFilterFields;
    const searchValue: ISearchInputValue = useSelector((state: IRPStore) => state.search.formValues.search);

    const onPromotionListFilterChange = usePromotionListFilterChange();

    const onChange = (newFormValues: {type?: PromotionType}) => {
        dispatch(promotionListFilterFormActions.update(newFormValues));

        if (searchValue.tabType === SearchTab.Regions) {
            onPromotionListFilterChange(newFormValues.type || undefined, searchValue?.regions?.[0]?.slug);
        } else {
            onPromotionListFilterChange(newFormValues.type || undefined);
        }
    };

    return (
        <div className={cx(promotionListHeader, props.className)}>
            <PromotionListHeaderResults type={formValues.type} />

            <PromotionListFilters onChange={onChange} values={formValues} />
        </div>
    );
};

const promotionListHeader = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column-reverse",
    rowGap: "2.4rem",

    md: {
        flexDirection: "row",
        columnGap: "1.6rem",
        rowGap: 0
    }
});
import {useDispatch, useSelector} from "react-redux";
import {css, cx} from "@panda/css";
import type {Dispatch} from "redux";

import type {IFormValuesAction} from "@pg-mono/form";

import {IRPStore} from "../../../app/rp_reducer";
import {ISearchInputValue} from "../../../search/components/ISearchInputValue";
import {SearchTab} from "../../../search/types/SearchTab";
import {promotionListFilterFormActions} from "../../actions/promotion_list_filter_fields_actions";
import {PromotionType} from "../../helpers/PromotionType";
import {usePromotionListFilterChange} from "../hooks/usePromotionListFilterChange";
import {IPromotionListFilterFields, PromotionListFilters} from "./filters/PromotionListFilters";
import {PromotionListHeaderResults} from "./PromotionListHeaderResults";

interface IProps {
    className?: string;
}
export const PromotionListHeader = (props: IProps) => {
    const dispatch: Dispatch<IFormValuesAction<unknown>> = useDispatch();

    const formValues = useSelector((state: IRPStore) => state.promotionList.form.formValues) as IPromotionListFilterFields;
    const searchValue: ISearchInputValue = useSelector((state: IRPStore) => state.search.formValues.search);

    const onPromotionListFilterChange = usePromotionListFilterChange();

    const onChange = (newFormValues: {type?: PromotionType}) => {
        dispatch(promotionListFilterFormActions.update(newFormValues));

        if (searchValue.tabType === SearchTab.Regions) {
            onPromotionListFilterChange(newFormValues.type || undefined, searchValue?.regions?.[0]?.slug);
        } else {
            onPromotionListFilterChange(newFormValues.type || undefined);
        }
    };

    return (
        <div className={cx(promotionListHeader, props.className)}>
            <PromotionListHeaderResults type={formValues.type} />

            <PromotionListFilters onChange={onChange} values={formValues} />
        </div>
    );
};

const promotionListHeader = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column-reverse",
    rowGap: "2.4rem",

    md: {
        flexDirection: "row",
        columnGap: "1.6rem",
        rowGap: 0
    }
});
